import React from 'react';

import PropTypes from 'prop-types';

import Tooltip from './Tooltip';
import { ToolTipWrapper } from '../css';
import RichText from '../../../richText';

const FieldGuide = ({ tooltip, isRichText = false }) => {
  return (
    <ToolTipWrapper>
      <Tooltip direction="auto" width="250px">
        {isRichText ? <RichText data={tooltip} /> : tooltip}
      </Tooltip>
    </ToolTipWrapper>
  );
};

FieldGuide.propTypes = {
  tooltip: PropTypes.string.isRequired,
  isRichText: PropTypes.bool
};

export default FieldGuide;
